import { GenericBackendResponse } from '../genericBackendResponse';

export type EmployeeGenderType = 'M' | 'F';
export type EmployeeCategoryType = 'DIRECTOR' | 'NON_DIRECTOR' | 'TECHNICAL_DIRECTOR';

export interface InviteEmployeeMinimal {
	nif: string;
	email: string;
	name: string;
	firstSurname: string;
	lastSurname?: string;
	birthdate: string; // DD/MM/YYYY
	gender: EmployeeGenderType;
	// Campos condicionales
	grossAnnualSalary?: number;
	employmentStartDate?: string; // DD/MM/YYYY
	category?: EmployeeCategoryType;
	collectiveAgreementGroup?: string;
}

export interface EmployeeEnrollmentError {
	email: string;
	nif: string;
	error: string;
}

export interface InviteEmployeesMinimalResult {
	totalEmployeesProcessed: number;
	totalEmployeesCreated: number;
	totalEmployeesExisted: number;
	totalEmployeesReactivated?: number;
	totalEmailsSended: number;
	errors?: EmployeeEnrollmentError[];
}

const inviteEmployeesMinimal = async (
	token: string,
	companyId: string,
	employees: InviteEmployeeMinimal[]
): Promise<GenericBackendResponse<InviteEmployeesMinimalResult>> => {
	const response = await fetch(
		`${process.env.REACT_APP_BASE_API}/companies/${companyId}/invite-employees-minimal`,
		{
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`
			},
			body: JSON.stringify({ employees })
		}
	);

	if (!response.ok) {
		throw new Error('Network response was not ok');
	}

	return response.json();
};

export default inviteEmployeesMinimal;
